import { FETCH_ALL, FETCH_ALL_FAILURE, FETCH_ALL_SUCCESS } from './constants';

export const myFavouritePassengersReducer = (
  state = {
    isFetching: false,
    passengers: null,
  },
  action,
) => {
  switch (action.type) {
    case FETCH_ALL:
      return { ...state, isFetching: true };
    case FETCH_ALL_FAILURE:
      return { isFetching: false, passengers: null };
    case FETCH_ALL_SUCCESS:
      return { isFetching: false, passengers: action.payload.passengers };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/containers/FavouritePassengers/reducer.js